module.exports = __webpack_public_path__ + "static/media/canva.b8f13636.svg";